/**
 * Design-filtered product gallery.
 *
 * Media are alt-tagged "Design N" and the "Design" option's values are
 * "Design 1".."Design N". This filters the gallery (main slider + thumbnail
 * slider) down to only the media whose alt matches the currently selected
 * Design value, and re-filters whenever the variant changes.
 *
 * Safety: does nothing (all media stays visible, exactly as shipped) unless
 * BOTH are true for a given product's gallery:
 *   - it has a "Design" option (rendered by product-variant-picker.liquid as
 *     a fieldset with class `product-form__input--design`), and
 *   - at least one of its media items has an alt matching "Design <number>".
 * Media tagged "Design N" that has no matching option value (e.g. spare
 * shots on capped products) is hidden while any real design is selected —
 * that's expected.
 *
 * Hooks the theme's existing variant-change mechanism: product-info.js
 * publishes PUB_SUB_EVENTS.variantChange (assets/constants.js /
 * assets/pubsub.js) after it has already updated the media gallery DOM and
 * jumped to the variant's featured media — we only add/remove our hide class
 * on top of that, so we don't fight the existing variant-image jump.
 */
(function () {
  if (window.__akDesignGalleryLoaded) return;
  window.__akDesignGalleryLoaded = true;

  var DESIGN_ALT_PATTERN = /^design\s+\d+$/i;
  var HIDE_CLASS = 'ak-design-photo--hidden';

  function sectionIdFromGallery(mediaGallery) {
    return mediaGallery.id.replace(/^MediaGallery-/, '');
  }

  function getDesignFieldset(sectionId) {
    var variantSelects = document.getElementById('variant-selects-' + sectionId);
    if (!variantSelects) return null;
    return variantSelects.querySelector('.product-form__input--design');
  }

  function getSelectedDesignValue(designFieldset) {
    var checked = designFieldset.querySelector('input:checked');
    return checked ? checked.value.trim() : null;
  }

  function galleryHasDesignTaggedMedia(mediaGallery) {
    var items = mediaGallery.querySelectorAll('[data-media-alt]');
    for (var i = 0; i < items.length; i++) {
      if (DESIGN_ALT_PATTERN.test((items[i].getAttribute('data-media-alt') || '').trim())) return true;
    }
    return false;
  }

  function applyDesignFilter(mediaGallery, designFieldset) {
    var selected = getSelectedDesignValue(designFieldset);
    if (!selected) return;
    var selectedLower = selected.toLowerCase();

    var firstVisibleMainId = null;
    mediaGallery.querySelectorAll('.product__media-list > li[data-media-alt]').forEach(function (el) {
      var matches = (el.getAttribute('data-media-alt') || '').trim().toLowerCase() === selectedLower;
      el.classList.toggle(HIDE_CLASS, !matches);
      if (matches && !firstVisibleMainId) firstVisibleMainId = el.dataset.mediaId;
    });

    mediaGallery.querySelectorAll('.thumbnail-list > li[data-media-alt]').forEach(function (el) {
      var matches = (el.getAttribute('data-media-alt') || '').trim().toLowerCase() === selectedLower;
      el.classList.toggle(HIDE_CLASS, !matches);
    });

    if (!firstVisibleMainId) return;

    // If the item the theme already made active got hidden by our filter (e.g. the
    // variant's featured image wasn't set to match its design), jump to the first
    // photo of the selected design using the gallery's own setActiveMedia — the same
    // mechanism the theme itself uses, so we stay consistent with its behavior.
    var activeItem = mediaGallery.querySelector('.product__media-list > li.is-active');
    var activeIsVisible = activeItem && !activeItem.classList.contains(HIDE_CLASS);
    if (!activeIsVisible && typeof mediaGallery.setActiveMedia === 'function') {
      mediaGallery.setActiveMedia(firstVisibleMainId, false);
    }
  }

  function setUpGallery(mediaGallery) {
    var sectionId = sectionIdFromGallery(mediaGallery);
    var designFieldset = getDesignFieldset(sectionId);
    if (!designFieldset) return; // no "Design" option on this product
    if (!galleryHasDesignTaggedMedia(mediaGallery)) return; // no alt follows the convention

    applyDesignFilter(mediaGallery, designFieldset);
  }

  function init() {
    document.querySelectorAll('media-gallery[id^="MediaGallery-"]').forEach(setUpGallery);
  }

  // Wait for DOMContentLoaded: this script is rendered inside
  // snippets/product-media-gallery.liquid, which appears earlier in the document
  // than the <script src="media-gallery.js"> tag in sections/main-product.liquid.
  // Both are deferred, so they run in document order — ours first — meaning
  // customElements.define('media-gallery', ...) hasn't registered yet and
  // mediaGallery.setActiveMedia() isn't callable. DOMContentLoaded fires only
  // after every deferred script has run, so by then the element is upgraded.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var sectionId = event && event.data && event.data.sectionId;
      if (!sectionId) return;
      var mediaGallery = document.getElementById('MediaGallery-' + sectionId);
      if (!mediaGallery) return;
      var designFieldset = getDesignFieldset(sectionId);
      if (!designFieldset) return;
      if (!galleryHasDesignTaggedMedia(mediaGallery)) return;
      applyDesignFilter(mediaGallery, designFieldset);
    });
  }
})();
